module.exports = __webpack_public_path__ + "9922ef36352004115e0a3857f687c8eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/mobile-top.svg
// module id = 81
// module chunks = 0